import { useRef, useEffect, useState } from 'react';
import $ from 'jquery';
import m from "../../prime-src/prepare";
import Exit from "./Exit";

m.dict = {};
m.dict.array = [["A", "B"]];
m.dict.indexes = [];

export default function Memorizing() {
  const [autoSelect, setAutoSelect] = useState(true);
  const [fromIndex, setFromIndex] = useState(1);
  const [count, setCount] = useState(20);
  const [cutoff, setCutoff] = useState(0.6);
  const [question, setQuestion] = useState(0);
  const [question0, setQuestion0] = useState("Word");
  const [question1, setQuestion1] = useState("Meaning");
  const [progress, setProgress] = useState(-1);
  const [progressCorrect, setProgressCorrect] = useState(-1);
  const [progressLength, setProgressLength] = useState(1);
  const [showAnswer, setShowAnswer] = useState(false);
  const ignore = useRef(false);

  function initialEffect() {
    $("#memo-container").hide();
    let savedFromIndex = m.localStorage.getItem("m.dict.fromIndex");
    if (savedFromIndex && !isNaN(Number(savedFromIndex))) {
      setFromIndex(parseInt(savedFromIndex));
    }
    let savedCount = m.localStorage.getItem("m.dict.count");
    if (savedCount && !isNaN(Number(savedCount))) {
      setCount(parseInt(savedCount));
    }
    let savedCutoff = m.localStorage.getItem("m.dict.cutoff");
    if (savedCutoff && !isNaN(Number(savedCutoff))) {
      setCutoff(parseFloat(savedCutoff));
    }
    m.dict.memoSetting = async function (elem) {
      let $elem=$(elem);
      let $reco=$elem.parents(".reco");
      let uri=m.unescapeHTML($reco.find(">.textURI").html().trim());
      m.dict.uri = uri;
      let r=m.userRecos[uri];
      let userR=r;
      if (!m.myPage && m.myIndex) {
        r=m.myRecos[uri];
        if (!r) {
          r=m.myRecos[uri]={ uri, down: false };
          await m.getAndFillRecoInNewReco(r);
          if (!r.has) {
            let strHeads = "uri\tdo";
            let strContents = m.encloseStr(uri) + "\treco";

            let title = userR.title;
            strHeads += "\ttitle";
            strContents += "\t" + m.encloseStr(title);

            let cats = userR.cats;
            strHeads += "\tcats";
            strContents += "\t" + m.encloseStr(cats);

            let desc = userR.desc;
            strHeads += "\tdesc";
            strContents += "\t" + m.encloseStr(desc);

            strHeads += "\tval";
            strContents += "\t" + m.encloseStr("10.0/10");

            let strRecoDo = strHeads + "\n" + strContents;
            let $result = m.$numbers_of_recos.add("#error-msg");

            await m.rmb_me(m.reco_do, { strRecoDo, $result, uri, cats:userR.cats }, true);
          }
        }
      }
      let dictionary = r.descR["#dictionary"] || r.descR["#dictionary:"] || r.descR["#사전"] || r.descR["#사전:"];
      if (dictionary) {
        m.dict.array = await m.strToJSON(dictionary.val.trim());
        setQuestion(0);
        setQuestion0(m.escapeOnlyTag(m.dict.array[0][0]));
        setQuestion1(m.escapeOnlyTag(m.dict.array[0][1]));
      } else {
        m.dict.array = [["A", "B"]]
      }
      let memorizing_result = r.cmtR["#memorizing-result"];
      if (memorizing_result) {
        m.dict.result = await m.strToJSON(memorizing_result.val.trim(), true, true);
        for (let i = 1; i < m.dict.result.length; i++) {
          let resultI = m.dict.result[i];
          resultI.index = Number(resultI.i.substring(1));
          resultI.Try = Number(resultI.Try);
          resultI.Correct = Number(resultI.Correct);
        }
      } else {
        m.dict.result = await m.strToJSON(`i\t${m.dict.array[0][0]}\t${m.dict.array[0][1]}\tTry\tCorrect\tRecentest`, true, true);
      }
    };
    m.dict.cutRecentest = function (str) {
      if (str.length > 10) {
        return str.substring(str.length - 10);
      }
      return str;
    }
    m.dict.findIndexes = function (fromIndex, count, cutoff) {
      let sorted = [];
      for (let i = fromIndex; i < fromIndex + count && i < m.dict.array.length; i++) {
        let resultI = m.dict.result[`i${i}`];
        if (resultI) {
          let correctRatio = m.memoCalcCorrectRatio(resultI.Recentest);
          if (correctRatio <= cutoff) {
            sorted.push(i);
            m.dict.array[i].random = Math.random();
          } else {
            count++;
          }
        } else {
          sorted.push(i);
          m.dict.array[i].random = Math.random();
        }
      }
      return sorted;
    };
    m.dict.saveResult = async function () {
      m.dict.currentResult = [];
      m.dict.currentResult.push(m.dict.result[0]);
      for (let i = 0; i < m.dict.initialIndexes.length; i++) {
        let index = `i${m.dict.initialIndexes[i]}`
        if (m.dict.result[index]) {
          m.dict.currentResult.push(m.dict.result[index]);
        }
      }
      // console.log(`m.dict.result:`, m.dict.result);
      let resultStr = String(await m.JSONtoStr(m.dict.result));
      // console.log(`resultStr:`, resultStr);
      let uri = m.dict.uri;
      if (m.myIndex) {
        $("#memo-in-setting .err-msg").html(m.memoArrayToTableHTML(m.dict.currentResult));
        let r = m.myRecos[uri];
        if (r) {
          if (!r.cmtR?.["#memorizing-result"]) {
            r.cmtR["#memorizing-result"] = { key: "#memorizing-result" }
            r.cmtR.push(r.cmtR["#memorizing-result"]);
          }
          r.cmtR["#memorizing-result"].val = "\n" + resultStr + "\n\n\n";
          let strHeads = `uri\tdo\tcmt`;
          let strContents = `${m.encloseStr(uri)}\tchange\t${m.encloseStr(m.descCmtRToString(r.cmtR)).trim()}`

          let strRecoDo = strHeads + "\n" + strContents;
          let $result = m.$numbers_of_recos.add("#error-msg");

          await m.rmb_me(m.reco_do, { strRecoDo, $result, uri, cats:r.cats }, true);
        }
        else {
          $("#memo-in-setting .err-msg").html(`You have no reco on this uri=${uri}.`+m.memoArrayToTableHTML(m.dict.currentResult));
        }
      }
      else {
        $("#memo-in-setting .err-msg").html("To save the result, you have to log-in to Recoeve.net!"+m.memoArrayToTableHTML(m.dict.currentResult));
      }
    };
  }

  useEffect(() => {
    if (!ignore.current) {
      initialEffect();
    }

    return () => {
      ignore.current = true;
    };
  }, []);

  return (
    <div id="memo-container"><div id="memo">
      <div className="title">Memorizer</div>
      <Exit onClick={() => {
        m.dict.saveResult();
        $("#memo-in-setting").show();
        $("#memo-in-progress").hide();
        $("#memo-container").hide();
      }}></Exit>
      <div id="memo-in-setting">
        <label className="auto-select"><input id="auto-select" className="auto-select" checked={autoSelect} onChange={(e) => setAutoSelect(val => e.target.checked)} type="checkbox" />{' '}[--Auto Select--]</label>
        <table><tbody>
          <tr>
            <td>
              <label htmlFor="from">[--From--] :</label>
            </td>
            <td>
              <input id="input-from" name="from" type="number" value={fromIndex} min={1} onChange={(e) => {
                setFromIndex(val => Number(e.target.value));
                m.localStorage.setItem("m.dict.fromIndex", e.target.value);
              }} />
            </td>
          </tr>
          <tr>
            <td>
              <label htmlFor="count">[--Count--] :</label>
            </td>
            <td>
              <input id="input-count" name="count" type="number" value={count} min={5} onChange={(e) => {
                setCount(val => Number(e.target.value));
                m.localStorage.setItem("m.dict.count", e.target.value);
              }} />
            </td>
          </tr>
          <tr>
            <td>
              <label htmlFor="cut-off-ratio">[--Cutoff ratio--] :</label>
            </td>
            <td>
              <input id="input-cut-off-ratio" name="cut-off-ratio" type="number" value={cutoff} min={0} max={1} step={0.1} onChange={(e) => {
                setCutoff(val => Number(e.target.value));
                m.localStorage.setItem("m.dict.cutoff", e.target.value);
              }} />
            </td>
          </tr>
          <tr>
            <td>
              <label htmlFor="question">Question</label>
            </td>
            <td>
              <select name="question" id="question" size={2} value={question} onChange={(e) => {
                setQuestion(val => Number(e.target.value));
              }}>
                <option value={0}>{question0}</option>
                <option value={1}>{question1}</option>
              </select>
            </td>
          </tr>
        </tbody></table>
        <div className="err-msg"></div>
        <div className="bottom-buttons">
          <button id="memo-start" className="full-width darkolivegreen" onClick={() => {
            // console.log(`fromIndex:${typeof fromIndex} ${fromIndex}, count:${typeof count} ${count}, cutoff:${typeof cutoff} ${cutoff}`);
            m.dict.indexes=m.dict.findIndexes(parseInt(String(fromIndex)), parseInt(String(count)), parseFloat(String(cutoff)));
            m.heapsort(m.dict.array, "random", m.dict.indexes, m.dict.indexes.length);
            // console.log(`m.dict.array:`, m.dict.array);
            // console.log(`m.dict.indexes:`, m.dict.indexes);
            m.dict.initialIndexes = m.dict.indexes.slice();
            if (m.dict.indexes.length > 0) {
              setProgressLength(m.dict.indexes.length);
              setProgress(0);
              setProgressCorrect(0);
              $("#memo-in-setting").hide();
              $("#memo-in-progress").show();
              $("#memo-in-setting .err-msg").html("");
            } else {
              $("#memo-in-setting .err-msg").html("No matched dictionary in the above condition!");
            }
          }}>Start</button>
        </div>
      </div>
      <div id="memo-in-progress" style={{display: "none"}}>
        <div id="progress-bars">
          <div className="correct" style={{width: `${progressCorrect/progressLength*100.0}%`}}>{progressCorrect}</div>
          <div className="wrong" style={{width: `${(progress-progressCorrect)/progressLength*100.0}%`}}>{progress-progressCorrect}</div>
          <div className="left" style={{width: `${(progressLength-progress)/progressLength*100.0}%`}}>{progressLength-progress}</div>
        </div>
        <div className="vertical-container" id="memo-question">
          <div className="vertically-centered" style={{whiteSpace: "pre-wrap"}}>{m.dict.array?.[m.dict.indexes?.[progress-progressCorrect]]?.[question]}</div>
        </div>
        <div className="vertical-container" id="memo-answer">
          <div className="vertically-centered" style={{whiteSpace: "pre-wrap"}}>
            {showAnswer ? m.dict.array?.[m.dict.indexes?.[progress-progressCorrect]]?.[question===0 ? 1 : 0] : ""}
            {showAnswer ? (m.dict.array?.[m.dict.indexes?.[progress-progressCorrect]]?.[2]?.trim() ? <><br />{m.dict.array?.[m.dict.indexes?.[progress-progressCorrect]]?.[2]}</> : "") : ""}
          </div>
        </div>
        <div className="bottom-buttons">
          <button id="memo-show-answer" className="full-width green" style={{display: !showAnswer ? "block" : "none"}} onClick={() => {
            // $("#memo-show-answer").hide();
            // $("#memo-correct, #memo-wrong").show();
            setShowAnswer(true);
          }}>Show Answer</button>
          <button id="memo-correct" className="half-width darkolivegreen" style={{display: showAnswer ? "block" : "none"}} onClick={() => {
            // $("#memo-correct, #memo-wrong").hide();
            // $("#memo-show-answer").show();
            let resultI = m.dict.result[`i${m.dict.indexes[progress-progressCorrect]}`];
            if (!resultI) {
              resultI = ["i", "A", "B", "Try", "Correct", "Recentest"];
              resultI.i = `i${m.dict.indexes[progress-progressCorrect]}`;
              resultI[m.dict.array[0][0]] = m.dict.array[m.dict.indexes[progress-progressCorrect]][0];
              resultI[m.dict.array[0][1]] = m.dict.array[m.dict.indexes[progress-progressCorrect]][1];
              resultI.Try = 0;
              resultI.Correct = 0;
              resultI.Recentest = "";
              m.dict.result[`i${m.dict.indexes[progress-progressCorrect]}`] = resultI;
              m.dict.result.push(resultI);
            }
            resultI.Try += 1;
            resultI.Correct += 1;
            resultI.Recentest = m.dict.cutRecentest(resultI.Recentest+"O");
            setShowAnswer(false);
            m.dict.indexes.splice(progress-progressCorrect, 1);
            if (progress === progressLength-1) {
              m.dict.saveResult();
              if (m.dict.indexes.length === 0) {
                $("#memo-in-progress").hide();
                $("#memo-in-setting").show();
              } else {
                setProgress(0);
                setProgressCorrect(0);
                m.heapsort(m.dict.array, "random", m.dict.indexes, m.dict.indexes.length);
                setProgressLength(m.dict.indexes.length);
              }
            } else {
              setProgress(progress+1);
              setProgressCorrect(progressCorrect+1);
            }
          }}>Correct</button>
          <button id="memo-wrong" className="half-width darkred" style={{display: showAnswer ? "block" : "none"}} onClick={() => {
            // $("#memo-correct, #memo-wrong").hide();
            // $("#memo-show-answer").show();
            let resultI = m.dict.result[`i${m.dict.indexes[progress-progressCorrect]}`];
            if (!resultI) {
              resultI = ["i", "A", "B", "Try", "Correct", "Recentest"];
              resultI.i = `i${m.dict.indexes[progress-progressCorrect]}`;
              resultI[m.dict.array[0][0]] = m.dict.array[m.dict.indexes[progress-progressCorrect]][0];
              resultI[m.dict.array[0][1]] = m.dict.array[m.dict.indexes[progress-progressCorrect]][1];
              resultI.Try = 0;
              resultI.Correct = 0;
              resultI.Recentest = "";
              m.dict.result[`i${m.dict.indexes[progress-progressCorrect]}`] = resultI;
              m.dict.result.push(resultI);
            }
            resultI.Try += 1;
            resultI.Recentest = m.dict.cutRecentest(resultI.Recentest+"X");
            setShowAnswer(false);
            m.dict.array[m.dict.indexes[progress-progressCorrect]].random = Math.random();
            if (progress === progressLength-1) {
              m.dict.saveResult();
              setProgress(0);
              setProgressCorrect(0);
              m.heapsort(m.dict.array, "random", m.dict.indexes, m.dict.indexes.length);
              setProgressLength(m.dict.indexes.length);
            } else {
              setProgress(progress+1);
            }
          }}>Wrong</button>
        </div>
      </div>
    </div></div>
  );
}
